module.exports = __webpack_public_path__ + "media/images/homes/Itemimport-b3dba83a0f0589bf413c72b15ae29347.png";